import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material";
import MUIBox from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { convertPxToRem } from "../../util-functions";
const StyledTitle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.largeTextStrong), { color: theme.palette.primaryBlackText.main, marginBottom: convertPxToRem(24) })));
const StyledPanel = styled(MUIBox)(({ theme }) => ({
    margin: "0",
    padding: convertPxToRem(24),
    border: `${convertPxToRem(1)} solid ${theme.palette.grey04.main}}`,
}));
export const Panel = ({ title, testId, children }) => (_jsxs(StyledPanel, Object.assign({ "data-testid": testId }, { children: [title && _jsx(StyledTitle, { children: title }), children] })));
